import React from "react";
import { withRouter } from "react-router-dom";
import userIcon from "../../../assets/user.svg";
import Boop from "../../common/Boop";

const buttonStyle = { lineHeight: "10px", height: "10px" };

const HeaderDropdown = ({ left, className = "", style = {}, history }) => {
  const logout = () => {
    window.localStorage.removeItem("jwt");
    history.push("/login");
  };

  return (
    <li className="dropdown">
      <span className="mx-5">
        <Boop timing={200} y={3}>
          <img
            className=""
            src={userIcon}
            alt="user"
            style={{ height: "36px", width: "36px", marginBottom: "-3px" }}
          />
        </Boop>
      </span>
      <ul className="drop">
        <li>
          <button
            type="button"
            style={buttonStyle}
            onClick={async () => {
              await logout();
            }}
          >
            Log Out
          </button>
        </li>
      </ul>
    </li>
  );
};

export default withRouter(HeaderDropdown);
